export default __webpack_public_path__ + "img/cYwcpAGF.b622a5b7.svg";